module.exports = __webpack_public_path__ + "static/media/people.184768d1.png";